<template>
  <div class="view view-home">
    <top-bar v-if="isPortalReady" />
    <carousel
      :carousel-class="'home-carousel'"
      v-if="banners.length > 0"
      @beforeChange="checkVideoPlay"
    >
      <template slot-scope="props">
        <div
          class="slide banner carousel-inner-image"
          style="width: 100%"
          v-for="(banner, i) in banners"
          :key="banner.id"
          :data-active-slide="props.current === i"
        >
          <div
            class="container"
            :class="{
              'container-has-video': banner.isLoaded && banner.isPlayerVisible,
              'banner-content-hidden': !banner.isHovered,
            }"
          >
            <div
              class="container-video"
              :id="'container-video-' + banner.id"
              :style="{
                backgroundImage:
                  banner.foto_principal == ''
                    ? 'url(' + banner.foto_principal.includes('/fl_lossy/')
                      ? banner.foto_principal.replace('http:', 'https:')
                      : banner.foto_principal
                          .replace('upload', 'upload/fl_lossy')
                          .replace('http:', 'https:') + ')'
                    : 'none',
              }"
              @mouseover="toggleHover(banner, true)"
              @mouseleave="toggleHover(banner, false, 1000)"
            >
              <img
                v-if="!banner.isLoaded && !banner.isPlayerVisible"
                :src="
                  banner.foto_principal.includes('/fl_lossy/')
                    ? banner.foto_principal.replace('http:', 'https:')
                    : banner.foto_principal
                        .replace('upload', 'upload/fl_lossy')
                        .replace('http:', 'https:')
                "
              />

              <div v-show="banner.isPlayerVisible">
                <div
                  :id="'home-banner-video-' + banner.id"
                  class="home-banner-video"
                  :class="{
                    'banner-content-hidden': !banner.isPlayerVisible,
                  }"
                  @click="pauseVideo(i)"
                ></div>
              </div>

              <div class="banner-content-video-movil">
                <div
                  class="banner-video-controls mostrar-movil"
                  style="margin: auto; padding-bottom: 80px"
                  v-if="banner.playerIndex !== false && banner.isLoaded"
                >
                  <button
                    class="bg-trans"
                    @click="pauseVideo(i, false, $event)"
                  >
                    <img
                      :src="
                        banner.isPlaying
                          ? require('@/assets/images/pause.svg')
                          : require('@/assets/images/play.svg')
                      "
                      class="banner-video-play"
                      :alt="banner.isPlaying ? 'Pausar' : 'Reproducir'"
                    />
                  </button>
                  <button class="bg-trans" @click="replay(banner)">
                    <img
                      :src="require('@/assets/images/reload.svg')"
                      class="banner-video-replay"
                      alt="Reiniciar"
                    />
                  </button>
                  <button class="bg-trans" @click="toggleMute(banner)">
                    <img
                      :src="
                        !banner.isMuted
                          ? require('@/assets/images/volume-up.svg')
                          : require('@/assets/images/volume-off.svg')
                      "
                      class="banner-video-mute"
                      :alt="banner.isMuted ? 'Escuchar' : 'Silenciar'"
                    />
                  </button>
                </div>
              </div>

              <div class="banner-content-home">
                <h1 v-html="banner.titulo"></h1>
                <h3 v-html="banner.descripcion"></h3>
                <div
                  v-if="banner.link_boton != '' && banner.texto_boton != ''"
                  class="banner-comprar"
                >
                  <a
                    class="btn banner-button btn-primary"
                    :href="banner.link_boton"
                    v-if="
                      banner.link_boton != '#registro' &&
                      banner.link_boton != '#login'
                    "
                  >
                    {{ banner.texto_boton }}
                  </a>
                  <a
                    class="btn banner-button btn-primary"
                    href="#"
                    @click="toggleRegistroModal(true)"
                    v-if="banner.link_boton == '#registro'"
                  >
                    {{ banner.texto_boton }}
                  </a>
                  <a
                    class="btn banner-button btn-primary"
                    href="#"
                    @click="toggleLoginModal(true)"
                    v-if="banner.link_boton == '#login'"
                  >
                    {{ banner.texto_boton }}
                  </a>
                  <span
                    v-if="banner.precio && banner.precio != '0'"
                    class="banner-precio carousel-precios"
                  >
                    {{ banner.precio }}
                  </span>
                </div>
                <div
                  class="banner-video-controls ocultar-movil"
                  v-if="banner.playerIndex !== false && banner.isLoaded"
                >
                  <button
                    class="bg-trans"
                    @click="pauseVideo(i, false, $event)"
                  >
                    <img
                      :src="
                        banner.isPlaying
                          ? require('@/assets/images/pause.svg')
                          : require('@/assets/images/play.svg')
                      "
                      class="banner-video-play"
                      :alt="banner.isPlaying ? 'Pausar' : 'Reproducir'"
                    />
                  </button>
                  <button class="bg-trans" @click="replay(banner)">
                    <img
                      :src="require('@/assets/images/reload.svg')"
                      class="banner-video-replay"
                      alt="Reiniciar"
                    />
                  </button>
                  <button class="bg-trans" @click="toggleMute(banner)">
                    <img
                      :src="
                        !banner.isMuted
                          ? require('@/assets/images/volume-up.svg')
                          : require('@/assets/images/volume-off.svg')
                      "
                      class="banner-video-mute"
                      :alt="banner.isMuted ? 'Escuchar' : 'Silenciar'"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </carousel>

    <Countdown />

    <block-static destacado="home" />

    <div class="container">
      <div class="home-curso-list">
        <h3 class="home-curso-list-title">Cursos</h3>
        <curso-list
          :cursos="cursos"
          columnas="6"
          :show_curso="show_curso"
          @cursoClick="verCurso"
        />
      </div>
    </div>
    <site-footer v-if="isPortalReady" :verFooter="true" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import TopBar from "../components/TopBar";
import CursoList from "../components/CursoList";
import SiteFooter from "../components/SiteFooter";
import BlockStatic from "../components/BlockStatic";
import Countdown from "../components/Countdown";
import {
  getCategoriaDeProducto,
  getProductoDeCategoria,
  eventKlaviyo,
} from "../utilities/data";
import { wait } from "../utilities/util";
import Carousel from "../components/Carousel";

export default {
  name: "home",
  components: {
    TopBar,
    CursoList,
    SiteFooter,
    Carousel,
    BlockStatic,
    Countdown,
  },
  data() {
    return {
      banners: [],
      videosLoaded: false,
      playerRetryCount: 0,
      show_curso: 0,
      verFooter: false,
    };
  },
  watch: {
    isPortalReady(val, old) {
      if (val && !old && this.videosLoaded) {
        this.loadBanners();
      }
    },
    //ACTIVAR IMPRESION DE PRODUCTOS
    cursos(val, old) {
      let impression = [];
      val.forEach((curso) => {
        impression.push({
          name: curso.producto.producto, // Name or ID is required.
          id: curso.producto.id,
          price: curso.producto.precio,
          category: curso.categoria.categoria,
          list: "Home",
          position: curso.categoria.posicion,
        });
      });
      dataLayer.push({
        event: "impressions",
        ecommerce: {
          currencyCode: "CLP",
          impressions: impression,
        },
      });
    },
  },
  computed: {
    cursos() {
      return this.portal.categorias
        .map((categoria) => {
          return {
            categoria,
            producto: getProductoDeCategoria(this.portal, categoria.id),
          };
        })
        .filter((producto) => producto.categoria !== false);
    },
    ...mapState(["portal", "isPortalReady"]),
  },
  methods: {
    scrollElement() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;

        //console.log(document.documentElement.scrollTop +" - "+(window.innerHeight*((this.show_curso)/5))+ " - "+document.documentElement.offsetHeight)

        if (
          document.documentElement.scrollTop >
          window.innerHeight * (this.show_curso / 5)
        ) {
          this.show_curso = this.show_curso + 6;

          //console.log("CURSOS A MOSTRAR "+ this.show_curso)

          this.verFooter = true;
        }
      };
    },
    toggleLoginModal(toggle) {
      this.$store.commit("togglePortalLoginModal", toggle);
    },
    toggleRegistroModal(toggle) {
      this.$store.commit("togglePortalRegistroModal", toggle);
    },
    verCurso(categoria, producto) {
      //CLICK PRODUCTO
      dataLayer.push({
        event: "productClick",
        ecommerce: {
          click: {
            actionField: { list: "Home" }, // Optional list property.
            products: [
              {
                name: producto.producto, // Name or ID is required.
                id: producto.id,
                price: producto.precio,
                category: categoria.categoria,
                position: categoria.posicion,
              },
            ],
          },
        },
      });

      this.$router.push({
        name: "curso",
        params: {
          guid: categoria.guid,
        },
      });
    },
    /**
     * Click en un link del banner.
     */
    linkBanner(link) {
      if (link != "") {
        if (link.substring(0, 1) == "/") {
          this.$router.push({
            path: link,
          });
        } else {
          window.location = link;
        }
      }
    },
    /**
     * Carga un jwplayer por cada banner que tenga video.
     */
    loadPlayer(banner) {
      // Esperar que el player este disponible
      if (
        typeof window.jwplayer === "undefined" ||
        document.querySelector("#home-banner-video-" + banner.id) == null
      ) {
        if (this.playerRetryCount < 10) {
          this.playerRetryCount++;
          return wait(() => {
            this.loadPlayer(banner);
          }, 900);
        } else if (this.contadorWait == 10) {
          console.log("ERROR AL CARGAR SCRIPT");
        }
      }

      this.$api
        .getPlayerEmbed("media", banner.banners_videos[0].video)
        .then((response) => {
          let player = JSON.parse(response.data.player);
          if ("message" in player) return false;

          let sources = player[0].playlist[0].sources;
          // Buscar el tamaño más grande para calcular el alto.
          let ref = sources.reduce(
            (prev, item) => {
              if (item.hasOwnProperty("width") && item.hasOwnProperty("height"))
                if (item.width > prev.width) return item;

              return prev;
            },
            {
              width: 0,
              height: 0,
            }
          );

          let videoSize = this.getVideoSize(banner, ref);

          let jwplayer = window
            .jwplayer("home-banner-video-" + banner.id)
            .setup({
              file: sources[0].file,
              // width: videoSize.width,
              // height: videoSize.height,
              width: "100%",
              height: "16:9",
              mute: false,
              volume: 30,
            })
            .setControls(false)
            .on("ready", (e) => {
              banner.isLoaded = true;
              banner.isPlayerVisible = true;
              if (banner.isPlaying) jwplayer.play();
              banner.isPlaying = true;
              banner.isMuted = jwplayer.getMute();
            })
            .on("play", () => {
              banner.isPlaying = true;
              banner.isPlayerVisible = true;
            })
            .on("pause", () => {
              banner.isPlaying = false;
              banner.isHovered = true;
            })
            .on("complete", () => {
              banner.isHovered = true;
              banner.isPlayerVisible = false;
              banner.isPlaying = false;
              banner.isLoaded = false;
            });

          this.players[banner.playerIndex] = jwplayer;

          // Si es el primer video, reproducir.
          if (this.banners[0].id == banner.id) {
            setTimeout(() => {
              this.players[banner.playerIndex].play();
              banner.isPlaying = true;
            }, 500);
          }
        })
        .catch((error) => console.log("ERROR EMBED HOME", error));
    },
    /**
     * Pasa por los banners y agrega videos a la lista de players.
     */
    loadBanners() {
      this.videosLoaded = true;
      let playersCount = 0;
      this.portal.banners
        .sort((a, b) => {
          if (a.posicion < b.posicion) return -1;
          if (a.posicion > b.posicion) return 1;
          return 0;
        })
        .forEach((banner, i) => {
          if (banner.tipo == "1") {
            if (
              typeof banner.banners_videos !== "undefined" &&
              banner.banners_videos.length > 0
            ) {
              this.banners.push({
                ...banner,
                playerIndex: Number(playersCount),
                isLoaded: false,
                isPlaying: false,
                isHovered: true,
                isPlayerVisible: false,
                isMuted: true,
              });
              let index = this.banners.length - 1;
              this.$nextTick(() => {
                this.loadPlayer(this.banners[index]);
              });
              playersCount++;
            } else {
              this.banners.push({
                ...banner,
                playerIndex: false,
                isLoaded: false,
                isPlaying: false,
                isHovered: true,
              });
            }
          }
        });
    },

    /**
     * Reproducir el video si no se está reproduciendo, mostrar el título y ocultarlo a los 3 segundos.
     */
    checkVideoPlay(current, next) {
      if (
        this.banners[current].playerIndex !== false &&
        this.players[this.banners[current].playerIndex].getState() == "playing"
      )
        this.pauseVideo(current);

      let banner = this.banners[next];
      banner.isHovered = true;
      if (banner.playerIndex !== false) {
        if (banner.isLoaded) {
          this.players[banner.playerIndex].play();
          wait(() => {
            banner.isHovered = false;
          }, 3000);
        } else {
          banner.isPlaying = true;
        }
      }
    },
    /**
     * Pausa (o reanuda) video.
     */
    pauseVideo(index, tap, $event) {
      console.log("pausing", index, tap, $event);
      if (this.banners[index].playerIndex !== false) {
        let player = this.players[this.banners[index].playerIndex];
        if (player.getState() == "playing") player.pause();
        if (["idle", "paused"].includes(player.getState())) {
          player.play();
          this.$set(this.banners, "isPlaying", true);
          this.$set(this.banners, "isPlayerVisible", true);
          if (tap) {
            setTimeout(() => {
              this.$set(this.banners, "isHovered", false);
            }, 1000);
          }
        }
      }
    },
    /**
     * Muestra / oculta info del video.
     */
    toggleHover(banner, toggle, delay) {
      // Ignorar si no tiene video
      if (banner.playerIndex !== false)
        setTimeout(() => {
          banner.isHovered = toggle;
        }, delay || 0);
    },
    getVideoSize(banner, initialWidthHeight) {
      let width = document.querySelector("#container-video-" + banner.id)
        .clientWidth;
      let height =
        (width * initialWidthHeight.height) / initialWidthHeight.width;
      return {
        width,
        height,
      };
    },
    resizeVideos() {
      this.banners.forEach((banner) => {});
    },
    toggleMute(banner) {
      if (banner.playerIndex !== false) {
        this.players[banner.playerIndex].setMute(!banner.isMuted);
        banner.isMuted = !banner.isMuted;
      }
    },
    replay(banner) {
      if (banner.playerIndex !== false && banner.isLoaded) {
        this.players[banner.playerIndex].seek(0).play();
        setTimeout(() => {
          banner.isHovered = false;
        }, 1000);
      }
    },
  },
  created() {
    this.players = [];
  },
  mounted() {
    this.scrollElement();
    // Si ya el portal está cargado y se cargaron los videos, cargar los players.
    if (this.isPortalReady && !this.videosLoaded) this.loadBanners();

    window.addEventListener("resize", this.resizeVideos);

    let postData = {
      event: "Home " + this.portal.nombre,
    };
    this.$store.dispatch("eventKlaviyo", postData).then((response) => {});
  },
};
</script>
